// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme--light.v-data-table\n  .v-data-table-header\n  th.sortable\n  .v-data-table-header__icon {\n  color: #fff !important\n}\n", ""]);
// Exports
module.exports = exports;
